import { useCallback, useState } from 'react';
import { RoundingRule } from 'repository/timekeeper/@types/RoundingRules';
import { TimekeeperService } from 'services/TimekeeperService';

const timekeeperService = new TimekeeperService();

export const useRoundingRulesQuery = () => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<RoundingRule[]>([]);

    const loadData = useCallback(async () => {
        try {
            setLoading(true);
            const data = await timekeeperService.rounding_rules.getRoundingRules();
            const orderedData = data.sort((a, b) => a.rounding_rule_id - b.rounding_rule_id);
            setRows(orderedData as RoundingRule[]);
        } catch (error) {
            console.error('Error loading rounding rules:', error);
            setLoading(false);
            setRows([]);
        } finally {
            setLoading(false);
        }
    }, []);

    return { rows, setRows, loading, setLoading, loadData };
};
